import { config as luminateConfig } from '@frx/frx-services';
import { useConstituentInteractions } from '@frx/frx-react-context';
import { useCallback, useMemo } from 'react';
import { useApiParams } from './use-api-params';

export const useSocial = () => {
  const luminateProperties = luminateConfig(window.location);
  const { ctx, handleUpdateInteraction, handleLogInteraction } = useApiParams({
    id: luminateProperties.sharingIsCaringTypeId,
    subject: 'sharing_is_caring',
  });
  const { data: sharingIsCaringInteraction } = useConstituentInteractions(ctx);

  const handleSharingIsCaringInteraction = useCallback(() => {
    if (sharingIsCaringInteraction?.interaction.length) {
      return handleUpdateInteraction(
        sharingIsCaringInteraction?.interaction[0]
      );
    }
    handleLogInteraction(ctx);
  }, [
    ctx,
    handleLogInteraction,
    handleUpdateInteraction,
    sharingIsCaringInteraction?.interaction,
  ]);

  const value = useMemo(
    () => ({
      sharingIsCaringInteraction,
      handleSharingIsCaringInteraction,
    }),
    [handleSharingIsCaringInteraction, sharingIsCaringInteraction]
  );

  return { ...value };
};
